(() => {
  angular
  .module('finance')
  .controller('finance.views.billingAccounts.createEditBillingAccounts',
    CreateEditBillingAccountsController
  );

  CreateEditBillingAccountsController.$inject = [
    '$scope',
    '$state',
    '$stateParams',
    'abp.services.finance.commonLookup',
    'Hms.Finance.KnownBillingAccountType',
    'Hms.Finance.KnownBillingAccountEntityTypes',
    'abp.service.finance.billingAccount',
    'abp.services.app.commonLookup',
    'Hms.Users.User',
  ];

  function CreateEditBillingAccountsController(
    $scope,
    $state,
    $stateParams,
    commonLookupSvc,
    enumFinanceKnownBillingAccountType,
    enumFinanceKnownBillingAccountEntityTypes,
    billingAccountSvc,
    portalCommonLookupSvc,
    constsUser
  ) {
    const vm = this;
    vm.constsUser = constsUser;
    vm.billingAccount = {
      billingAddress: {
        street: '',
        city: '',
        state: '',
        countrySubdivisionId: '',
        postcode: '',
        countryCode: ''
      }
    };

    vm.loading = 0;
    vm.saving = 0;
    vm.isCreate = $stateParams.isCreate;
    vm.editIrbmMyInvoisSettingsWidget = null;
    vm.billingAccountId = null;

    vm.permissions = {
      create: abp.auth.isGranted(
        'HealthMetrics.Finance.BillingAccounts.Create'
      ),
    };

    vm.enums = {
      knownBillingAccountType: enumFinanceKnownBillingAccountType,
      knownBillingAccountEntityTypes: enumFinanceKnownBillingAccountEntityTypes,
    };

    vm.cancel = cancel;
    vm.saveAll = saveAll;
    vm.getAccountOwners = getAccountOwners;
    vm.localizeEntityTypes = localizeEntityTypes;
    vm.selectedAccountOwnerDetails = selectedAccountOwnerDetails;

    init ();

    function init() {
      getAccountOwners();
      localizeEntityTypes();
    }

    function getAccountOwners() {
      commonLookupSvc.getAccountOwners().success((data) => {
        vm.accountOwners = data.items;
      });
    }

    function selectedAccountOwnerDetails(accountOwnerId) {
      vm.countryCode = _.find(vm.accountOwners, ['id', accountOwnerId]).countryCode;
      getCurrencyCodeByCountryCode();
    }

    function getCurrencyCodeByCountryCode() {
      const input = vm.billingAccount.countryCode;

      // Get the currency code based on the account owner.

      vm.loading += 1;
      portalCommonLookupSvc
      .getCurrencyCodeByCountryCode({countryCode: input})
      .success((data) => {
        vm.billingAccount.currencyCode = data.currencyCode;
      })
      .finally(() => {
        vm.loading -= 1;
      });
    }

    // Check form validity.
    function validateForm() {
      const form = $scope.billingAccountCreateEditForm;
      return App.isFormValid(form);
    }

    function saveAll() {
      if (!validateForm()) {
        abp.message.warn(App.localize('OneOrMoreInputValueIsInvalid'));
        return;
      }

      save()
    }

    function save() {
      if (vm.isCreate) {
        createBillingAccount()
      } else {
        setTaxIdentifiers()
      }
    }

    function createBillingAccount() {
      vm.saving += 1;
      billingAccountSvc
      .createBillingAccount(vm.billingAccount)
      .success((data) => {
        abp.notify.success(App.localize('SuccessfullyCreated'));

        vm.billingAccountId = data.id;
        vm.isCreate = false;
        setTaxIdentifiers();
      })
      .finally(() => {
        vm.saving -= 1;
      });
    }

    function cancel() {
      if (!$scope.billingAccountCreateEditForm.$dirty) toggleCancel(false);
      else {
        abp.message.confirm(
          App.localize('UnsavedChangesConfirmation'),
          App.localize('AreYouSure'),
          (d) => {
            if (d) {
              toggleCancel();
            }
          }
        );
      }
    }

    // Cancel creation or edit.
    function toggleCancel() {
      if (vm.isCreate) window.history.back();
      else {
        // TO DO: Handle for editing billing account.
      }
    }

    function localizeEntityTypes() {
      _.forEach(vm.enums.knownBillingAccountEntityTypes, (entityType) => {
        entityType.displayName = App.localize(entityType.name);
      })
    }

    function setTaxIdentifiers() {
      const payload = vm.editIrbmMyInvoisSettingsWidget.taxIdentifiers[0];
      payload.billingAccountId = vm.billingAccountId;

      vm.editIrbmMyInvoisSettingsWidget.error = false;
      vm.editIrbmMyInvoisSettingsWidget.validateForm();
      const watch = $scope.$watch('vm.editIrbmMyInvoisSettingsWidget.error', () => {
        if (vm.editIrbmMyInvoisSettingsWidget.loading === 0
            && !vm.editIrbmMyInvoisSettingsWidget.error) {
          $state.go('finance.billingAccounts');
          watch(); // deregister the watch
        }
      }, true);
    }
  }
})();